/**@type {import('./types').DataFilterValueType} */
export default {
  label: 'All',
  filterBy: undefined,
  filterValue: undefined,
  filterOperator: 'equal',
  searchIn: undefined,
  searchValue: undefined,
  searchOperator: 'contains'
};